<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup class="items-no-padding" :title="$t('Upload_evidence')" :active.sync="popupActive">

      <div class="upload-img mt-5 mb-2">
        <vs-button icon-pack="feather" icon="icon-plus" @click="$refs.updateImgInput1.click()">{{ $t('upload') }}</vs-button>
      </div>

      <input type="file" class="hidden" ref="updateImgInput1" @change="updateCurrImg1" accept="*.*">

      <vs-list-header icon-pack="feather" icon="icon-users" :title="$t('Upload_evidence')"></vs-list-header>
      <vs-list-item v-if="uploadPdfForReportCard && uploadPdfForReportCard.preuve && uploadPdfForReportCard.preuve.length" icon-pack="feather" icon="icon-check" :title="$t('Old_evidence')">
        <!-- <vx-tooltip :text="$t('download_old_report_card')" color="warning" style="z-index: 99999 !important;"> -->
        <a href="#" @click="OldReportCard(uploadPdfForReportCard.preuve)" class="flex items-center text-sm">
          <feather-icon icon="FilePlusIcon" svgClasses="w-5 h-5" />
          <span class="ml-2"> {{$t('Download')}} </span>
        </a>
        <!-- </vx-tooltip> -->
      </vs-list-item>
      <vs-list-item v-for="(item, index) in dataImg_information" :key="index" icon-pack="feather" icon="icon-check" :title="item.name"></vs-list-item>

            <div class="vx-row">
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p> {{ $t('Comments') }} <b style="color: #ff6141">*</b></p>
            <vs-input v-model="uploadPdfForReportCard.commentaire" class="w-full" name="commentaire" />
          </div>
            </div>
      <div class="upload-img mt-5 mb-2">
        <vs-button :disabled="!dataImg_information.length || !uploadPdfForReportCard.commentaire" icon-pack="feather" color="success" icon="icon-check-circle" @click="uploadReportCard">{{ $t('Submit') }}</vs-button>
      </div>
    </vs-popup>
    <vx-card
      v-if="filter"
      ref="filterCard"
      :title="$t('Filter')"
      class="user-list-filters mb-4"
      actionButtons
      @refresh="initInput"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <p class="mb-2">
            {{ $t('matter_by_teachers') }}
            <b style="color: #ff6141;">*</b>
          </p>
          <v-select
            :options="professeurClasseMatieres"
            @search="getProfesseurClasseMatiere"
            :clearable="true"
            label="libelle"
            v-model="input.professeurClasseMatiere"
            class="w-full"
          />
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
          <p class="mb-2">
            {{ $t('partition') }}
            <b style="color: #ff6141;">*</b>
          </p>
          <v-select
            :disabled="input.professeurClasseMatiere ? false : true"
            :options="partitions"
            @search="getPartition"
            :clearable="true"
            label="long_label"
            v-model="input.partition"
            class="w-full"
          />
        </div>
        <!--<div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p>
              {{ $t('Date') }}
            </p>
            <datepicker
              v-model="input.dateEvaluation"
              name="datePresence"
            ></datepicker>
          </div>-->
      </div>
    </vx-card>

    <vs-table
      :noDataText="$t('No_data_Available')"
      ref="table"
      :data="presences"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown
            v-if="false"
            vs-trigger-click
            class="dd-actions cursor-pointer mr-4 mb-4"
          >
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
            >
              <span class="mr-2">{{ $t('Actions') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="addMultiple(0)">
                <span class="flex items-center">
                  <feather-icon
                    icon="FilePlusIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{ $t('multiple_add') }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div
              class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning"
              @click="filter = !filter"
            >
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>

        <div class="flex flex-wrap">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{
                  param.paginate.page * param.paginate.length -
                  (param.paginate.length - 1)
                }}
                -
                {{
                  taille - param.paginate.page * param.paginate.length > 0
                    ? param.paginate.page * param.paginate.length
                    : taille
                }}
                {{ $t('of_sur') }} {{ taille }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                :key="indexItem"
                v-for="(item, indexItem) in itemsPerPages"
                @click=";(param.paginate.length = item), getPresences()"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input
            icon-pack="feather"
            icon="icon-search"
            :placeholder="$t('Search')"
            v-model="search"
            class="is-label-placeholder mb-8"
          />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="libelle">{{ $t('Date_of_attendance') }}</vs-th>
        <vs-th sort-key="libelle">
          {{ $t('start_time') }}
        </vs-th>
        <vs-th sort-key="libelle">
          {{ $t('end_time') }}
        </vs-th>
        <vs-th sort-key="inscription.eleve.full_name">
          {{ $t('Student') }}
        </vs-th>
        <vs-th sort-key="libelle">
          {{ $t('Comments') }}
        </vs-th>
        <vs-th>{{ $t('action') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{
                  $store.state.convertDateTime(new Date(tr.presence.datePresence)).date
                }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.presence.heureDebut }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.presence.heureFin }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.inscription.eleve.full_name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.commentaire }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip :text="$t('Upload_evidence')" color="success">
                    <feather-icon
                      @click="uploadPdfForReportCard = tr, popupActive=true"
                      style="color: #28C76F"
                      icon="UploadCloudIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                  <vx-tooltip v-if="tr.preuve" :text="$t('download_aproved_report_card')" color="success">
                    <feather-icon
                      style="color: #28C76F"
                      icon="FilePlusIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current"
                      class="mr-2"
                      @click="OldReportCard(tr.preuve)"
                    />
                  </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'

let base_self = ''
const input_tempon = {
  id: null,
  partition: '',
  datePresence: '',
  professeurClasseMatiere: ''
}

export default {
  components: { flatPickr, Datepicker },
  data () {
    return {
      dataImg1: [],
      dataImg_information: [],
      uploadPdfForReportCard: '',
      popupActive: false,
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      label: ['eleve', 'full_name'],
      paramProfesseurClasseMatiere: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          salle__is_active: true,
          salle__classe__is_active: true,
          salle__classe__niveau__is_active: true,
          classeMatiere__anneeScolaire__id: this.$store.state.anneeScolaire.id
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      professeurClasseMatieres: [],
      inscriptions: [],
      partitions: [],
      filter: true,
      search: '',
      param: {},
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      presences: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  watch: {
    input: {
      handler () {
        if (
          base_self.input1.professeurClasseMatiere !==
          base_self.input.professeurClasseMatiere
        ) {
          if (
            !base_self.input.professeurClasseMatiere ||
            base_self.input.professeurClasseMatiere === ''
          ) {
            delete base_self.paramPartition.filter[
              'niveauTypePartition__anneeScolaire__id'
            ]
            delete base_self.paramPartition.filter[
              'niveauTypePartition__niveau__id'
            ]

            base_self.partitions = []
            base_self.presences = []
          } else {
            base_self.paramPartition.filter[
              'niveauTypePartition__anneeScolaire__id'
            ] = base_self.$store.state.anneeScolaire.id
            base_self.paramPartition.filter['niveauTypePartition__niveau__id'] =
              base_self.input.professeurClasseMatiere.salle.classe.niveau.id

            base_self.getPartitionSimple()
          }
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
        base_self.getPresences()
      },
      deep: true
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getPresences()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [
          { inscription__eleve__full_name__icontains: value },
          { partition__long_label__icontains: value },
          { typeExamen__libelle__icontains: value },
          { professeurClasseMatiere__libelle__icontains: value }
        ]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getPresences()
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    addMultiple (id = 0) {
      base_self.$router
        .push(`/Student_management/Attendance/${id}`)
        .catch(() => {})
    },
    OldReportCard (link) {
      link = link.substring(1)
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`, '_blank')
    },
    updateCurrImg1 (input) {
      if (input.target.files && input.target.files[0]) {
        const length = input.srcElement.files.length
        for (let iuoy = 0; iuoy < length; iuoy++) {
          const reader = new FileReader()
          reader.onload = e => {
            // unshift
            base_self.dataImg1.unshift(e.target.result)
            base_self.dataImg_information.unshift(base_self.$refs.updateImgInput1.files[iuoy])
          }
          reader.readAsDataURL(input.target.files[iuoy])
        }
      }
    },
    uploadReportCard () {
      base_self.$vs.loading()
      const form = new FormData()
      form.append('id', base_self.uploadPdfForReportCard.id)
      form.append('commentaire', base_self.uploadPdfForReportCard.commentaire)
      const length = base_self.dataImg_information.length
      for (let iuoy = 0; iuoy < length; iuoy++) {
        console.log(base_self.dataImg_information[iuoy].name)
        form.append('preuve', base_self.dataImg_information[iuoy], base_self.dataImg_information[iuoy].name)
      }


      base_self.$http.put(`${base_self.$store.state.route_for_esm}PresenceInscription`, form)
        .then((response) => {

          window.getESM.success(base_self.$t('The_evidence_is_changed_successfully'), response)
          base_self.popupActive = false
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          window.getESM.error(base_self.$t('Evidence_changing_failed'), error)
          base_self.popupActive = false
          base_self.$vs.loading.close()
        })

      base_self.popupActive = false
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {
        const length = this.label.length
        let element = option
        for (let i = 0; i < length; i++) {
          if (!element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
                ` exist in options object ${JSON.stringify(option)}.\n` +
                'https://vue-select.org/api/props.html#getoptionlabel',
            )
          }

          element = element[this.label[i]]
        }

        // return option['created_at']
        return element
      }
      return option
    },
    getTypeExamenSimple () {
      delete base_self.paramTypeExamen.filter['libelle__icontains']
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}TypeExamen`,
          base_self.paramTypeExamen,
        )
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))

          // console.log('base_self.typeExamens: ', base_self.typeExamens)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getTypeExamen (search, loading) {
      loading(true)
      base_self.paramTypeExamen.filter['libelle__icontains'] = search
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}TypeExamen`,
          base_self.paramTypeExamen,
        )
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getPartitionSimple () {
      delete base_self.paramPartition.filter['long_label__icontains']
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}Partition`,
          base_self.paramPartition,
        )
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))

          // console.log('base_self.partitions: ', base_self.partitions)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getPartition (search, loading) {
      loading(true)
      base_self.paramPartition.filter['long_label__icontains'] = search
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}Partition`,
          base_self.paramPartition,
        )
        .then((response) => {
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getProfesseurClasseMatiereSimple () {
      delete base_self.paramProfesseurClasseMatiere.filter['libelle__icontains']
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`,
          base_self.paramProfesseurClasseMatiere,
        )
        .then((response) => {
          base_self.professeurClasseMatieres = JSON.parse(
            JSON.stringify(response.data.data),
          )
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getProfesseurClasseMatiere (search, loading) {
      loading(true)
      base_self.paramProfesseurClasseMatiere.filter[
        'libelle__icontains'
      ] = search
      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`,
          base_self.paramProfesseurClasseMatiere,
        )
        .then((response) => {
          base_self.professeurClasseMatieres = JSON.parse(
            JSON.stringify(response.data.data),
          )
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    edit (data) {
      base_self.sidebarData = JSON.parse(JSON.stringify(data))
      /* base_self.sidebarData.classe = base_self.sidebarData.classe.id
      base_self.sidebarData.inscription = base_self.sidebarData.inscription.id
      base_self.sidebarData.partition = base_self.sidebarData.partition.id */
      // base_self.detail__detail = false;
      base_self.toggleDataSidebar(true)
    },
    async presence_delete (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          // console.log('id: ', id)
          const params = {
            id
          }

          base_self.$http
            .delete(`${base_self.$store.state.route_for_esm}Presence`, { params })
            .then((response) => {
              window.getESM.success(
                base_self.$t('The_Attendance_is_deleted_successfully'),
                response,
              )
            })
            .catch(() => {
              window.getESM.error(base_self.$t('Attendance_removal_failed'))
            })
        }
      })
    },
    async getPresences () {
      if (
        base_self.input.professeurClasseMatiere &&
        base_self.input.professeurClasseMatiere.id &&
        base_self.input.partition &&
        base_self.input.partition.id
      ) {
        base_self.$vs.loading()

        base_self.param.filter['presence__professeurClasseMatiere__id'] =
        base_self.input.professeurClasseMatiere.id
        base_self.param.filter['presence__partition__id'] = base_self.input.partition.id
        base_self.param.filter['status'] = false
        console.log('base', base_self.param)
        base_self.$http
          .post(
            `${base_self.$store.state.route_for_esm}PresenceInscription`,
            base_self.param,
          )
          .then((response) => {
            console.log('success', response)
            base_self.presences = response.data.data
            base_self.taille = response.data.taille

            base_self.$vs.loading.close()
          })
          .catch((response) => {
            console.log('error', response)
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
            base_self.$vs.loading.close()
          })
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    PresenceWebSocket () {
      base_self.$store.state.webSocketFunction(base_self, 'presenceInscription')
    }
  },
  created () {
    base_self = this
    base_self.param = JSON.parse(
      JSON.stringify(base_self.$store.state.paramExamen),
    )

    base_self.PresenceWebSocket()
    base_self.getPresences()

    base_self.getProfesseurClasseMatiereSimple()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}
</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
